import {SvgIcon, useTheme} from '@mui/material';

export default function LibraryServiceIcon(props: { color?: string; }) {
	const {color = 'url(#paint0_linear_1397_2192)'} = props;
	const theme = useTheme();
	// @ts-ignore
	const first = theme.palette.primary[400];
	// @ts-ignore
	const second = theme.palette.primary[600];
	return (
		<SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none">
			<path opacity="0.4"
			      d="M15.9998 7.06659V28.4399C15.7732 28.4399 15.5332 28.3999 15.3465 28.2933L15.2932 28.2666C12.7332 26.8666 8.2665 25.3999 5.37317 25.0133L4.9865 24.9599C3.7065 24.7999 2.6665 23.5999 2.6665 22.3199V6.21326C2.6665 4.62659 3.95984 3.42659 5.5465 3.55993C8.3465 3.78659 12.5865 5.19993 14.9598 6.67993L15.2932 6.87993C15.4932 6.99993 15.7465 7.06659 15.9998 7.06659Z"
			      fill={color}/>
			<path
				d="M29.3333 6.22679V22.3201C29.3333 23.6001 28.2933 24.8001 27.0133 24.9601L26.5733 25.0135C23.6667 25.4001 19.1867 26.8801 16.6267 28.2935C16.4533 28.4001 16.24 28.4401 16 28.4401V7.06679C16.2533 7.06679 16.5067 7.00012 16.7067 6.88012L16.9333 6.73345C19.3067 5.24012 23.56 3.81345 26.36 3.57345H26.44C28.0267 3.44012 29.3333 4.62679 29.3333 6.22679Z"
				fill={color}/>
			<path
				d="M10.3335 12.3201H7.3335C6.78683 12.3201 6.3335 11.8667 6.3335 11.3201C6.3335 10.7734 6.78683 10.3201 7.3335 10.3201H10.3335C10.8802 10.3201 11.3335 10.7734 11.3335 11.3201C11.3335 11.8667 10.8802 12.3201 10.3335 12.3201Z"
				fill={color}/>
			<path
				d="M11.3335 16.3201H7.3335C6.78683 16.3201 6.3335 15.8667 6.3335 15.3201C6.3335 14.7734 6.78683 14.3201 7.3335 14.3201H11.3335C11.8802 14.3201 12.3335 14.7734 12.3335 15.3201C12.3335 15.8667 11.8802 16.3201 11.3335 16.3201Z"
				fill={color}/>
			<defs>
				<linearGradient id="paint0_linear_1397_2192" x1="15.7153" y1="3.54981" x2="2.00174" y2="3.92162"
				                gradientUnits="userSpaceOnUse">
					<stop stopColor={first}/>
					<stop offset="1" stopColor={second}/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
